import { isPreciousGem } from "../constants/gems";

export function countCommonGems(gemCounts = {}) {
  let total = 0;
  Object.entries(gemCounts).forEach(([gemId, rawCount]) => {
    const count = Number(rawCount) || 0;
    if (count <= 0 || isPreciousGem(gemId)) return;
    total += count;
  });
  return total;
}

export function canAffordWithSpecific(potion, gemCounts = {}) {
  const { specificGemId, specificGemCount } = potion.cost;
  return (Number(gemCounts[specificGemId]) || 0) >= specificGemCount;
}

export function canAffordWithCommon(potion, gemCounts = {}) {
  return countCommonGems(gemCounts) >= potion.cost.commonGemCount;
}

export function canAffordPotion(potion, gemCounts = {}) {
  return canAffordWithSpecific(potion, gemCounts) || canAffordWithCommon(potion, gemCounts);
}

export function computeMaxAffordableQuantity(item, gemCounts = {}, payment = "specific") {
  if (!item?.cost) return 0;

  const perSpecific = Number(item.cost.specificGemCount) || 0;
  const perCommon = Number(item.cost.commonGemCount) || 0;

  if (payment === "specific") {
    if (perSpecific <= 0) return 0;
    const owned = Number(gemCounts[item.cost.specificGemId]) || 0;
    return Math.floor(owned / perSpecific);
  }

  if (perCommon <= 0) return 0;
  return Math.floor(countCommonGems(gemCounts) / perCommon);
}

export function getOwnedCommonGems(gems = []) {
  return gems.filter((gem) => !isPreciousGem(gem.id) && (gem.count || 0) > 0);
}

export function buildAutoCommonGemAllocations(ownedCommonGems, requiredCount) {
  const required = Number(requiredCount) || 0;
  if (required <= 0) return {};

  let remaining = required;
  const allocations = {};

  for (const gem of ownedCommonGems) {
    if (remaining <= 0) break;
    const owned = Number(gem.count) || 0;
    if (owned <= 0) continue;
    const take = Math.min(owned, remaining);
    allocations[gem.id] = take;
    remaining -= take;
  }

  return allocations;
}
